import React from 'react'

export const Loader = () => {
	return (
		<div className="lds-ring mx-auto">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	)
}
